import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import AcceptCreditWrapper from "@components/layouts/acceptcreditWrapper";

export default function CarInjuryJusticeHome(): ReactElement {
    return (
        <AcceptCreditWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="Accept Credit"
                    domain="AcceptCredit.Cards"
                />
            </div>
        </AcceptCreditWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
